import "../node_modules/mockman-js/dist/style.css";

import Mockman from 'mockman-js';
export default function TestMockAPI() {
    return <div><Mockman /></div>
}
